import BillStatusBadge from './BillStatusBadge';

export default BillStatusBadge;
